<template>
    <div>
        <div class="modal is-active" v-show="showDeleteModal">
          <div class="modal-background"></div>
          <div class="modal-card">
              <header class="modal-card-head">
              <p class="modal-card-title">Delete Employee</p>
              <button class="delete"  @click="cancel" aria-label="close"></button>
              </header>
              <section class="modal-card-body">
              <!-- Content ... -->
              Are you sure do you want to delete <strong>{{employee.fullname}}</strong> permanently?
              </section>
              <footer class="modal-card-foot" style="justify-content:flex-end">
              <button :class="buttonDelete" @click="deletePermanently">Yes</button>
              <button class="button is-small" @click="cancel">No</button>
              </footer>
          </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import axios from "axios"
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data: ()=>({
    buttonDelete: appButton.isLoadingDanger(false)
  }),
  computed: {
    ...mapState("employee", {
      showDeleteModal: state => state.showDeleteModal,
      employee: state => state.employee
    })
  },
  methods: {
    ...mapActions("employee", ["openDeleteModal", "getPaginatedEmployees"]),
    deletePermanently() {
      this.buttonDelete= appButton.isLoadingDanger(true) 
      axios
        .delete(`api/employees/${this.employee.employeeId}`)
        .then(response => {
          appToast.success(response.data);
        })
        .catch(error => {
          console.log(response.data)
        })
        .then(() => {
          this.default();
        });
    },
    default() {
      this.getPaginatedEmployees({
        page: 1,
        pageSize: 10,
        query: ""
      });
      this.buttonDelete= appButton.isLoadingDanger(false) 
      this.openDeleteModal({
        showDeleteModal: false
      });
    },
    cancel() {
        this.default()
    }
  }
};
</script>
